import { Link } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
} from '@/core/components/ui/card';
import { ADMIN_NAV_CATEGORIES } from '../types/admin-types';
import { appConfig } from '@/core/config';

export function AdminMenu() {
  // Get version with fallback
  const { version, isFallback } = appConfig.getVersion();

  return (
    <div className="container mx-auto px-4 py-6 space-y-8">
      <div className="border-l-4 border-yellow-400 pl-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-xl font-semibold text-gray-900">EV Admin Panel</h1>
            <p className="text-gray-600 text-sm">
              Select a feature to navigate
            </p>
          </div>
          <div className="text-right">
            <p className="text-xs text-gray-500">Version</p>
            <p className="text-sm font-mono text-gray-700">
              {version}{isFallback && ' *'}
            </p>
          </div>
        </div>
      </div>

      {ADMIN_NAV_CATEGORIES.map((category) => (
        <div key={category.title} className="space-y-4">
          <h2 className="text-lg font-medium text-gray-700">{category.title}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {category.items.map((item) => (
              <Link key={item.path} to={item.path}>
                <Card className="h-full hover:shadow-md transition-shadow cursor-pointer hover:border-yellow-400">
                  <CardHeader>
                    <div className="flex items-center gap-3">
                      <div className="p-2 bg-yellow-100 rounded-lg">
                        <item.icon className="h-6 w-6 text-yellow-700" />
                      </div>
                      <div>
                        <CardTitle className="text-lg">{item.title}</CardTitle>
                        <CardDescription>{item.description}</CardDescription>
                      </div>
                    </div>
                  </CardHeader>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
